import { EventType, CreateEventTypeRequest, UpdateEventTypeRequest, EventTypeFilters } from '../types/eventType';
import api from './authService';

export const eventTypeService = {
  async getAllEventTypes(filters?: EventTypeFilters): Promise<EventType[]> {
    const response = await api.get('/event-types', {
      params: {
        search: filters?.search,
        isActive: filters?.isActive
      }
    });
    return response.data.success ? response.data.data : response.data;
  },

  async getActiveEventTypes(): Promise<EventType[]> {
    const response = await api.get('/event-types', { params: { isActive: true } });
    return response.data.success ? response.data.data : response.data;
  },

  async getEventTypeById(eventTypeId: string): Promise<EventType> {
    const response = await api.get(`/event-types/${eventTypeId}`);
    return response.data.success ? response.data.data : response.data;
  },

  async createEventType(eventTypeData: CreateEventTypeRequest): Promise<EventType> {
    const response = await api.post('/event-types', eventTypeData);
    return response.data.success ? response.data.data : response.data;
  },

  async updateEventType(eventTypeId: string, eventTypeData: UpdateEventTypeRequest): Promise<EventType> {
    const response = await api.put(`/event-types/${eventTypeId}`, eventTypeData);
    return response.data.success ? response.data.data : response.data;
  },

  async deleteEventType(eventTypeId: string): Promise<void> {
    await api.delete(`/event-types/${eventTypeId}`);
  }
};